import cn from 'clsx'

// types
import { UserSongStep } from 'modules/usersongs/selectors'

import styles from './progress.css'

type ProgressProps = {
  steps: Array<UserSongStep>
}

const ProgressBar = ({ steps }: ProgressProps): JSX.Element => (
  <div className={styles.wrapper}>
    <p>{`${steps.filter(step => step.completed).length}/${steps.length} steps completed`}</p>
    <div>
      {steps.map(step => (
        <div key={step.id} className={cn(step.completed && styles.active, styles.step)} />
      ))}
    </div>
  </div>
)

export default ProgressBar
